// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function unsetApplyRegex(st) {
  return {
          text: st.text,
          applyRegex: false,
          regex: st.regex,
          textAfterRegex: st.textAfterRegex
        };
}

function toggleApplyRegex(st) {
  if (st.applyRegex) {
    return {
            text: st.text,
            applyRegex: false,
            regex: st.regex,
            textAfterRegex: st.textAfterRegex
          };
  }
  var userRegex = new RegExp(st.regex);
  var textAfterRegex = Expln_utils_common.arrFlatMap(Common.multilineTextToNonEmptyLines(st.text).map(function (param) {
                            return Caml_option.null_to_opt(userRegex.exec(param));
                          }).filter(Belt_Option.isSome).map(Belt_Option.getExn).filter(function (captures) {
                      return captures.length > 1;
                    }).map(function (captures) {
                    return captures.slice(1);
                  }), (function (captures) {
                  return captures;
                })).map(function (prim) {
              if (prim == null) {
                return ;
              } else {
                return Caml_option.some(prim);
              }
            }).filter(Belt_Option.isSome).map(Belt_Option.getExn).join("\n");
  return {
          text: st.text,
          applyRegex: true,
          regex: st.regex,
          textAfterRegex: textAfterRegex
        };
}

function MM_cmp_asrts_to_skip(props) {
  var onCancel = props.onCancel;
  var onSave = props.onSave;
  var initRegex = props.initRegex;
  var initText = props.initText;
  var match = React.useState(function () {
        return {
                text: initText,
                applyRegex: false,
                regex: initRegex,
                textAfterRegex: ""
              };
      });
  var setState = match[1];
  var state = match[0];
  var actUpdateText = function (text) {
    Curry._1(setState, (function (st) {
            var st$1 = unsetApplyRegex(st);
            return {
                    text: text,
                    applyRegex: st$1.applyRegex,
                    regex: st$1.regex,
                    textAfterRegex: st$1.textAfterRegex
                  };
          }));
  };
  var actUpdateRegex = function (regex) {
    Curry._1(setState, (function (st) {
            var st$1 = unsetApplyRegex(st);
            return {
                    text: st$1.text,
                    applyRegex: st$1.applyRegex,
                    regex: regex,
                    textAfterRegex: st$1.textAfterRegex
                  };
          }));
  };
  var rndButtons = function (param) {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onSave, {
                              regex: state.regex,
                              asrtsToSkip: Expln_utils_common.arrFlatMap(Common.multilineTextToNonEmptyLines(state.applyRegex ? state.textAfterRegex : state.text), Common.getSpaceSeparatedValuesAsArray)
                            });
                      }),
                    variant: "contained",
                    children: "Save"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onCancel, undefined);
                      }),
                    variant: "outlined",
                    children: "Cancel"
                  }));
  };
  var rndText = function (param) {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, React.createElement(TextField, {
                    value: state.text,
                    label: "Assertions to skip",
                    size: "small",
                    style: {
                      width: "800px"
                    },
                    multiline: true,
                    maxRows: 10,
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actUpdateText, param);
                      }),
                    autoFocus: true
                  }), state.applyRegex ? null : rndButtons(undefined));
  };
  var rndRegex = function (param) {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(FormControlLabel, {
                        control: React.createElement(Checkbox, {
                              checked: state.applyRegex,
                              onChange: (function (param) {
                                  Curry._1(setState, toggleApplyRegex);
                                })
                            }),
                        label: "apply regular expression: "
                      }), React.createElement(TextField, {
                        value: state.regex,
                        label: "Regex to apply to each line",
                        size: "small",
                        style: {
                          width: "300px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actUpdateRegex, param);
                          })
                      })), state.applyRegex ? React.createElement(TextField, {
                      value: state.textAfterRegex,
                      label: "Assertions to skip (after regex applied)",
                      size: "small",
                      style: {
                        width: "800px"
                      },
                      multiline: true,
                      maxRows: 10
                    }) : null, state.applyRegex ? rndButtons(undefined) : null);
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 1,
              children: Caml_option.some(null)
            }, rndText(undefined), rndRegex(undefined));
}

var make = MM_cmp_asrts_to_skip;

exports.make = make;
/* react Not a pure module */
